import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import PropTypes from 'prop-types'

import './contact10.css'

const Contact10 = (props) => {
  const { t } = useTranslation()

  return (
    <div className="contact10-container1 thq-section-padding">
      <div className="contact10-max-width thq-section-max-width">
        <div className="contact10-content1 thq-flex-row">
          <div className="contact10-content2">
            <h2 className="thq-heading-2">
              {props.heading1 ?? (
                <Fragment>
                  <span className="contact10-text17">{t('contact10.heading')}</span>
                </Fragment>
              )}
            </h2>
            <p className="thq-body-large">
              {props.content1 ?? (
                <Fragment>
                  <span className="contact10-text20">
                    {t('contact10.content')}
                  </span>
                </Fragment>
              )}
            </p>
          </div>
        </div>
        <div className="contact10-content3 thq-flex-row">
          <div className="contact10-container2">
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2531.4!2d1.610889!3d50.767943!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNTDCsDQ2JzA0LjYiTiAxwrAzNiczOS4yIkU!5e0!3m2!1sen!2sfr!4v1"
                width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="contact10-image1 thq-img-ratio-16-9"
              title="Pic-nic d'Opale Location"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

Contact10.defaultProps = {
  location1ImageSrc:
    'https://images.unsplash.com/photo-1567706054195-bf733c67c07f?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc1NDIwMjk3OHw&ixlib=rb-4.1.0&q=80&w=1080',
  location2ImageAlt: 'image2Alt',
  location1: undefined,
  heading1: undefined,
  location1Description: undefined,
  location2: undefined,
  content1: undefined,
  location2Description: undefined,
  location1ImageAlt: 'image1Alt',
  location2ImageSrc:
    'https://images.unsplash.com/photo-1599581148873-b1df350d667f?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc1NDIwMjk3N3w&ixlib=rb-4.1.0&q=80&w=1080',
}

Contact10.propTypes = {
  location1ImageSrc: PropTypes.string,
  location2ImageAlt: PropTypes.string,
  location1: PropTypes.element,
  heading1: PropTypes.element,
  location1Description: PropTypes.element,
  location2: PropTypes.element,
  content1: PropTypes.element,
  location2Description: PropTypes.element,
  location1ImageAlt: PropTypes.string,
  location2ImageSrc: PropTypes.string,
}

export default Contact10
